import { render, staticRenderFns } from "./MemberPurchasedProductsBlock.vue?vue&type=template&id=2be83602&scoped=true"
import script from "./MemberPurchasedProductsBlock.vue?vue&type=script&lang=js"
export * from "./MemberPurchasedProductsBlock.vue?vue&type=script&lang=js"
import style0 from "./MemberPurchasedProductsBlock.vue?vue&type=style&index=0&id=2be83602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be83602",
  null
  
)

export default component.exports